import { render, staticRenderFns } from "./CustomFieldsController.vue?vue&type=template&id=d1c27000&scoped=true&"
import script from "./CustomFieldsController.vue?vue&type=script&lang=js&"
export * from "./CustomFieldsController.vue?vue&type=script&lang=js&"
import style0 from "./CustomFieldsController.vue?vue&type=style&index=0&id=d1c27000&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1c27000",
  null
  
)

export default component.exports